module.exports = __webpack_public_path__ + "static/media/adsk-products.c0702c36.txt";